import React from 'react'

import { thumbnailForPreviewFile } from '@sketch/modules-common'
import { StarNotificationFragment } from '@sketch/gql-types'

import { DocumentTileMedia } from './DocumentTileMedia'
import { StarIcon } from './StarPreview.styles'
import {
  Card,
  IconTile,
  Separator,
  Tile,
  TileMeta,
  TileTitle,
  TileWrapper,
} from './TileCard.styles'

interface StarPreviewProps {
  notification: StarNotificationFragment
}

export const StarPreview = ({ notification }: StarPreviewProps) => {
  const { share, workspace } = notification

  if (!share) return null

  const thumbnail = thumbnailForPreviewFile(
    share.version?.document?.previewFile
  )

  return (
    <Card>
      <TileWrapper>
        <Tile>
          <IconTile aria-hidden>
            <StarIcon />
          </IconTile>
          <TileTitle>New version</TileTitle>
        </Tile>

        <Separator />

        <Tile>
          <DocumentTileMedia src={thumbnail} alt={`Preview of ${share.name}`} />
          <TileTitle>{share.name}</TileTitle>
          {workspace?.name && <TileMeta>{workspace.name}</TileMeta>}
        </Tile>
      </TileWrapper>
    </Card>
  )
}
